// Universelles Drag & Drop für alle Upload-Flächen (gestrichelte „border-dashed“-Zonen):
// Dateien, die auf eine solche Zone gezogen werden, landen im zugehörigen <input type="file"> –
// damit funktioniert Drag & Drop überall, auch wo nur ein Klick-Picker gebaut wurde.
// Opt-out je Zone: data-no-dropzone. Nach `index.js`-Import aktiv.
const ZONE = '.border-dashed';
const HILITE = 'dropzone-active';

const domIndex = (root, el) => Array.prototype.indexOf.call(root.querySelectorAll('*'), el);

const findInput = (zone) => {
  const inner = zone.querySelector('input[type="file"]');
  if (inner) return inner;
  if (zone.tagName === 'LABEL' && zone.htmlFor) {
    const el = document.getElementById(zone.htmlFor);
    if (el && el.type === 'file') return el;
  }
  let scope = zone.parentElement;
  for (let i = 0; i < 5 && scope; i++) {
    const inputs = Array.from(scope.querySelectorAll('input[type="file"]'));
    if (inputs.length === 1) return inputs[0];
    if (inputs.length > 1) {
      const zi = domIndex(scope, zone);
      return inputs.sort((a, b) => Math.abs(domIndex(scope, a) - zi) - Math.abs(domIndex(scope, b) - zi))[0];
    }
    scope = scope.parentElement;
  }
  return null;
};

const zoneFor = (target) => {
  const z = target && target.closest ? target.closest(ZONE) : null;
  if (!z || z.hasAttribute('data-no-dropzone')) return null;
  return z;
};

const matchesAccept = (file, accept) => {
  if (!accept) return true;
  const rules = accept.split(',').map((r) => r.trim().toLowerCase()).filter(Boolean);
  const name = (file.name || '').toLowerCase();
  const type = (file.type || '').toLowerCase();
  return rules.some((r) => (r.startsWith('.') ? name.endsWith(r) : r.endsWith('/*') ? type.startsWith(r.slice(0, -1)) : type === r));
};

let current = null;
const clear = () => { if (current) { current.classList.remove(HILITE); current = null; } };

(function install() {
  if (typeof document === 'undefined') return;
  const style = document.createElement('style');
  style.textContent = `.${HILITE}{outline:3px solid #c8a55a!important;outline-offset:2px;background-color:rgba(200,165,90,.10)!important;transition:background-color .15s}`;
  document.head.appendChild(style);

  document.addEventListener('dragover', (e) => {
    if (!e.dataTransfer || !Array.from(e.dataTransfer.types || []).includes('Files')) return;
    const zone = zoneFor(e.target);
    if (!zone || !findInput(zone)) { clear(); return; }
    e.preventDefault();
    e.dataTransfer.dropEffect = 'copy';
    if (current !== zone) { clear(); current = zone; zone.classList.add(HILITE); }
  }, true);

  document.addEventListener('dragleave', (e) => {
    if (current && !current.contains(e.relatedTarget)) clear();
  }, true);

  document.addEventListener('drop', (e) => {
    const zone = zoneFor(e.target);
    clear();
    if (!zone || !e.dataTransfer || !e.dataTransfer.files || !e.dataTransfer.files.length) return;
    const input = findInput(zone);
    if (!input) return;
    e.preventDefault();
    e.stopPropagation();
    let files = Array.from(e.dataTransfer.files).filter((f) => matchesAccept(f, input.accept));
    if (!files.length) {
      window.dispatchEvent(new CustomEvent('dropzone-rejected', { detail: { accept: input.accept } }));
      return;
    }
    if (!input.multiple) files = files.slice(0, 1);
    try {
      const dt = new DataTransfer();
      files.forEach((f) => dt.items.add(f));
      input.files = dt.files;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    } catch { /* Browser ohne DataTransfer-Konstruktor */ }
  }, true);
})();
